import { render, staticRenderFns } from "./DeveloperIndicator.vue?vue&type=template&id=3b7da49c&scoped=true&"
import script from "./DeveloperIndicator.vue?vue&type=script&lang=ts&"
export * from "./DeveloperIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./DeveloperIndicator.vue?vue&type=style&index=0&id=3b7da49c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7da49c",
  null
  
)

export default component.exports